import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=37fbfb27&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_sign-up.scss?vue&type=style&index=0&id=37fbfb27&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbfb27",
  null
  
)

export default component.exports